import revertTitle from "./revertTitle";

const openLibraryResource = async (id, name, url) => {
  const instruction = 'open'
    + '|' + id
    + '|' + name + '.urbresource'
    + '|' + url;

  document.title = instruction;
  revertTitle();

};

export default openLibraryResource;
